import React from 'react';
import Button from '@/components/Button';
import styles from './index.module.css';
import emas1 from '../../assets/icon-01.png';

const Index: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img src={emas1} className={styles.icon} />
        <span>Dear Sir</span>
        <div className={styles.detail}>
          <div className={styles.invited}>You are invited to open and join the workspace.</div>
          <div className={styles.inviter}>
            Inviter:<u style={{ color: 'var(--superapp-primary-1)', fontWeight: '400' }}>sunwukong@huaguoshan.com</u>
          </div>
          <div className={styles.validity}>
            Validity of Invitation:
            <span style={{ color: '#585F7E', fontWeight: '400' }}>2022-12-30 20:20:15</span>
          </div>
          <Button
            style={{ borderRadius: 4, width: 142, height: 40, marginTop: '48px' }}
            type="primary"
          >
            Click to Join
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Index;
